import React, { useContext } from 'react';
import { string } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({ pipTimeout }) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path={routes.room.path} element={<routes.room.component />} />
        <Route path={routes.bath.path} element={<routes.bath.component />} />
        <Route
          path={routes.browse.path}
          element={
            channel === 'mobile' ? (
              <routes.browseMobile.component pageType="browse" />
            ) : (
              <routes.browse.component pageType="browse" />
            )
          }
        />
        <Route
          path={routes.search.path}
          element={
            channel === 'mobile' ? (
              <routes.searchMobile.component pageType="search" />
            ) : (
              <routes.search.component pageType="search" />
            )
          }
        />
        <Route
          exact
          path={routes.pep.path}
          element={channel === 'mobile' ? <routes.pepMobile.component /> : <routes.pep.component />}
        />
        <Route
          exact
          path={routes.product.path}
          element={
            channel === 'mobile' ? (
              <routes.productMobile.component pipTimeout={pipTimeout} />
            ) : (
              <routes.product.component pipTimeout={pipTimeout} />
            )
          }
        />
        <Route
          exact
          path={routes.paintReorder.path}
          element={
            channel === 'mobile' ? (
              <routes.paintReorderMobile.component pipTimeout={pipTimeout} />
            ) : (
              <routes.paintReorder.component pipTimeout={pipTimeout} />
            )
          }
        />
        <Route
          exact
          path={routes.collections.path}
          element={
            channel === 'mobile' ? (
              <routes.collectionsMobile.component />
            ) : (
              <routes.collections.component />
            )
          }
        />
        <Route
          exact
          path={routes.vendorCollections.path}
          element={
            channel === 'mobile' ? (
              <routes.vendorCollectionsMobile.component />
            ) : (
              <routes.vendorCollections.component />
            )
          }
        />
        <Route exact path={routes.compare.path} element={<routes.compare.component />} />
        <Route path={routes.styleQuiz.path} element={<routes.styleQuiz.component />} />
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  pipTimeout: string
};

App.defaultProps = {
  pipTimeout: null
};
